import React from 'react';
import {
  MarisaTakesCareContract,
  MarisaTakesCareDetails,
  MarisaTakesCareInsurance,
} from '~/scenes';
import { Stack } from '../stackNavigation';

export const TakesCareNavigation = (
  <Stack.Group>
    <Stack.Screen
      name="MarisaServicos_MarisaTakesCareDetails"
      component={MarisaTakesCareDetails}
    />
    <Stack.Screen
      name="MarisaServicos_MarisaTakesCareInsurance"
      component={MarisaTakesCareInsurance}
    />
    <Stack.Screen
      name="MarisaServicos_MarisaTakesCareContract"
      component={MarisaTakesCareContract}
    />
  </Stack.Group>
);
